export const MOBILE_BREAK = 768;
export const MD_BREAK = 1024;
export const PAGE_SIZE = 12;
